import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-56f5a3b3"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-flex align-items-center" }
const _hoisted_2 = ["type", "name", "value", "id", "checked"]
const _hoisted_3 = ["for"]

import { computed } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'radioInput',
  props: {
    modelValue: {
        type: [String, Number],
        default: "",
    },
    label: { type: String },
    name: { type: String },
    id: { type: String }, 
    valueAttr: { type: [String, Number], },
    type: { type: String, default: 'radio' },
     disabled: { type: Boolean, default: false },
     v: {
        type: Object,
    },
},
  setup(__props) {

const props = __props;

const valueX = computed(() => {
    if (props.valueAttr === 1 || props.valueAttr === 0) {

        return props.valueAttr === 1 ? 1 : 0;
    }
    else {
        return props.valueAttr
    }

}) 

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("input", {
      type: __props.type,
      class: "form-check-input",
      name: __props.name,
      value: valueX.value,
      id: __props.id,
      onChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:modelValue', valueX.value))),
      checked: __props.modelValue == valueX.value
    }, null, 40, _hoisted_2),
    _createElementVNode("label", {
      class: "col-form-label",
      for: __props.id,
      style: {"margin-inline-start":"10px"}
    }, _toDisplayString(__props.label), 9, _hoisted_3)
  ]))
}
}

})